export default __webpack_public_path__ + "static/media/GAMEAE_logo_white.780f44de.png";